export const emailTemplate = `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <style>
        * {
          box-sizing: border-box;
        }
        html, body {
          margin: 0;
        }
        a {
          background-color: #FB8C00;
          border-radius: 10px;
          color: #000;
          display: block;
          margin: 0 auto;
          padding: 10px;
          text-align: center;
          width: 50%;
        }
        div {
          margin: 0 auto;
          width: 100%;
          max-width: 500px;
        }
        img {
          max-width: 100%;
          height: auto;
        }
        h1 {
          display: inline-block;
          font-size: 22px;
          font-weight: normal;
          text-align: center;
          padding-top: 10px;
          width: 100%;
        }
        p {
          text-align: justify;
          margin: 0;
        }
      </style>
    </head>
    <body style="background-color:#263238; font-family:sans-serif; font-size:14px; line-height:1.4; padding-top:25px; width:100%;">
      <div style="padding-bottom:25px; padding-top:25px; text-align:center;">
        <img style="height:50px;" src="/assets/championship.png" alt="Championship Title Logo" />
      </div>
      <div style="line-height:0px; border-bottom:2px solid #D1B74F;">
        <img style="border-top-right-radius:10px; border-top-left-radius:10px;" src="/assets/city.jpg" alt="City" />
      </div>
      <div style="padding: 8px; background-color:#ffffff; border-bottom-right-radius:10px; border-bottom-left-radius:10px;">
        REPLACE_THIS_WITH_CONTENT
      </div>
      <div>
        <p style="color:#9A9EA6; font-size:10px; text-align:center;">
          The contents of this e-mail message and any attachments are confidential and may be legally privileged...
        </p>
        <p style="color:#f1f1f1; font-size:10px; text-align:center;">
          If you have any questions, please contact us at
          <a href="mailto:support@championshiptitle.com">support@championshiptitle.com</a>
        </p>
      </div>
    </body>
  </html>
`;
